<span [style.color]="margin <= 0 ? 'var(--signal-error-red)' : 'var(--signal-success-green)'"
  >{{ margin | number: '1.2-2' }}%</span
>
